import { useState } from "react"
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow"
import Categories from "../../../../components/AdminPortalComponents/ProductManagement/CategoryAndSubCategories/Categories/Categories"
import SubCategories from "../../../../components/AdminPortalComponents/ProductManagement/CategoryAndSubCategories/SubCategories/SubCategories"
import CategoryDetails from "../../../../components/AdminPortalComponents/ProductManagement/CategoryAndSubCategories/CategoryDetails/CategoryDetails"
import SubCategoriesDetails from "../../../../components/AdminPortalComponents/ProductManagement/CategoryAndSubCategories/SubCategoriesDetails/SubCategoriesDetails"
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"

const CategoryAndSubCategories = () => {
  
  const tabs = [
    { key: 'categories', label: 'Categories' },
    { key: 'subCategories', label: 'Sub-Categories' },
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  const [toggleDetail, setToggleDetail] = useState({
    category: false,
    subCategory: false,
  })

  const cardsData = [
    { title: "TOTAL CATEGORIES", value: 0 },
    { title: "TOTAL SUB CATEGORIES", value: 0 },
    { title: "RECENTLY ADDED", value: "Footwear Apparel & Accessories", muted: true },
    { title: "TOP CATEGORIES", value: "Footwear Apparel & Accessories", muted: true },
  ]

  const renderContent = () => {
    if (toggleDetail.category) {
      return <CategoryDetails setToggleDetail={setToggleDetail} />
    }

    if (toggleDetail.subCategory) {
      return <SubCategoriesDetails setToggleDetail={setToggleDetail} />
    }

    return (
      <>
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} bgColor="#9B9B9B" />
        {activeTab === "categories" && <Categories setToggleDetail={setToggleDetail} />}
        {activeTab === "subCategories" && <SubCategories setToggleDetail={setToggleDetail} />}
      </>
    )
  }

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f2f2f2", padding: "1rem" }}>
      <div className="shadow bg-white p-3">
        <div className="mb-3 fw-semibold fs-4">Categories and Subcategories</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className={`bg-white mt-3 shadow d-flex flex-column gap-2 ${!toggleDetail.category && !toggleDetail.subCategory && "p-3"}`}>{renderContent()}</div>
    </div>
  )
}

export default CategoryAndSubCategories
